import BaseApi from "@api/base.api";
import Http from "@services/http";
export default class ListsApi extends BaseApi {
    static get entity() {
        return "lists";
    }

        
    static async getPinned() {
        return await Http.get("pinned-lists", {
            embed: "userPinned",
            Pinned: true,
        });
    }      

    static async getAll() {
        return await Http.get("all-lists");
    }

    // Bulk delete multiple lists
    static async bulkDelete(payload = {}) {
        return await Http.post(`lists-bulk-delete`, payload);
    }

    //=============================ORDER(PROJECTS, DOCUMENTS, TAMER)========================================
    static async updateOrder(listId, payload = {}) {
        return await Http.post(`lists/${listId}/update-order`, payload);
    }

    //=============================(DELETE & BULK DELETE) FROM LIST(PROJECTS, DOCUMENTS, TAMER)========================================
    static async deleteFromList(listId, payload = {}) {
        return await Http.post(`lists/${listId}/delete-from-list`, payload);
    }

    //=============================(ADD TO LIST) (PROJECTS, DOCUMENTS, TAMER)========================================
    static async addProjectsToLists(listId, payload = {}) {
        return await Http.post(`lists/${listId}/add-projects-to-list`, payload);
    }

    static async addTamersToLists(listId, payload = {}) {
        return await Http.post(`lists/${listId}/add-tamers-to-list`, payload);
    }

    static async addDocumentsToLists(listId, payload = {}) {
        return await Http.post(`lists/${listId}/add-documents-to-list`, payload);
    }

    //=============================Share LIST(s) WITH (PROJECTS, TAMER, Business Unit)========================================
    static async shareLists(payload = {}) {
        return await Http.post(`lists/share-lists`, payload);
    }

    //=============================PINNING FUNCTIONALITY========================================
    static async pinList(listId) {
        return await Http.post(`user-pinned`, {
            list_id: listId,
            user_id: JSON.parse(localStorage.getItem('user'))?.id,
            type: 'list'
        });
    }

    static async unpinList(listId) {
        return await Http.delete(`user-pinned/${listId}`, {
            params: { 
                type: 'list',
                user_id: JSON.parse(localStorage.getItem('user'))?.id
            }
        });
    }

    static async togglePinList(listId) {
        return await Http.post(`user-pinned`, {
            list_id: listId,
            user_id: JSON.parse(localStorage.getItem('user'))?.id,
            type: 'list'
        });
    }

    static async bulkPinLists(listIds, pinnedStatus) {
        return await Http.post(`user-pinned/bulk-pin`, {
            list_ids: listIds,
            pinned_status: pinnedStatus
        });
    }

    // Leave a shared list
    static async leaveList(listId) {
        return await Http.post(`lists/${listId}/leave`);
    }
}
